export type PaymentConfirmationStatus = 'failed' | 'pending' | 'success'

export interface PaymentConfirmationVariant {
  iconBackgroundClassName: string
  description: string
  iconType: 'check' | 'hourglass' | 'x'
  title: string
}

export const paymentConfirmationVariants: Record<
  PaymentConfirmationStatus,
  PaymentConfirmationVariant
> = {
  failed: {
    iconBackgroundClassName: 'bg-error-50',
    description:
      "Le paiement n'a pas pu être traité. Votre réservation est en attente de paiement.",
    iconType: 'x',
    title: 'Paiement refusé',
  },
  pending: {
    iconBackgroundClassName: 'bg-[#E67320]',
    description:
      'Votre réservation a été créée. Elle sera confirmée dès réception de votre paiement.',
    iconType: 'hourglass',
    title: 'Réservation en attente de paiement',
  },
  success: {
    iconBackgroundClassName: 'bg-brand-100',
    description: 'Votre paiement a été accepté. Votre réservation est confirmée.',
    iconType: 'check',
    title: 'Réservation finalisée !',
  },
}
